var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_icons",
    "data-name": "Main icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28,3V1c0-.55-.45-1-1-1H1C.45,0,0,.45,0,1v2C0,3.55.45,4,1,4h3L0,8v23c0,.55.45,1,1,1h11v-4H4V4h20v24h-8v4h11c.55,0,1-.45,1-1V8s-4-4-4-4h3c.55,0,1-.45,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17,15.99c.55,0,1-.45,1-1v-1.99c0-.55-.45-1-1-1h-1s-4,0-4,0h0s-1,0-1,0c-.55,0-1,.45-1,1v1.99c0,.55.45,1,1,1h1v12.01h4v-12.01h1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegs);
export default __webpack_public_path__ + "static/media/legs.79ed4390b1e9c0f0a356e4226960ec26.svg";
export { ForwardRef as ReactComponent };